import { useId } from 'react';
import ClipboardButton from '~/components/ClipboardButton';
import { TextInput } from 'corso-admin-ui';

export default function CopyInput({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  const id = useId();
  return (
    <TextInput
      id={id}
      disabled
      required
      label={label}
      value={value}
      readOnly
      addon={{
        insideEnd: <ClipboardButton onClick={() => value} variant="ghost" />,
      }}
    />
  );
}
